import { Grid, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";

import Accordion from "./Accordion";

const FAQs = () => {
	const [FaqData, setFaqData] = useState([]);

	useEffect(() => {
		(async () => {
			const CmsFaqs = await axios.get(
				process.env.REACT_APP_DIRECTUS_URL +
					"/items/Appraisal_FAQs?filter[status][_eq]=published"
			);
			setFaqData(CmsFaqs.data.data);
		})();
	}, []);

	return (
		<>
			{FaqData.map((FAQ) => {
				return (
					<Grid item xs={12} sx={{ mb: "2px" }} key={FAQ.title}>
						<Accordion summary={FAQ.title}>
							<Typography>{FAQ.text}</Typography>
						</Accordion>
					</Grid>
				);
			})}
		</>
	);
};

export default FAQs;
